import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import BarGroup from './views/BarGroup.vue';
import Buy from './views/Buy.vue';
import BuyBar from './views/BuyBar.vue';
import OnlyBar from './views/OnlyBar.vue';
import Success from './views/Success.vue';
import MainPage from './views/MainPage.vue';
import Fail from './views/Fail.vue';
import Login from './views/Login.vue';
import SupportCulturalProgram from './views/SupportCulturalProgram.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'mainPage',
      component: MainPage,
    },
    {
      path: '/:theatreId/:session/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/:theatreId/:session/hall',
      name: 'home',
      component: Home,
    },
    {
      path: '/:theatreId/:session/support-cultural-program',
      name: 'support-cultural-program',
      component: SupportCulturalProgram,
    },
    {
      path: '/:theatreId/:session/bar',
      name: 'barGroup',
      component: BarGroup,
    },
    {
      path: '/:theatreId/:session/buy',
      name: 'buy',
      component: Buy,
    },
    {
      path: '/:theatreId/:session/success',
      name: 'success',
      component: Success,
    },
    {
      path: '/:theatreId/:session/fail',
      name: 'fail',
      component: Fail,
    },

    
    {
      path: '/:theatreId/:session/only-bar',
      name: 'onlyBar',
      component: OnlyBar,
    },
    {
      path: '/:theatreId/:session/buy-bar',
      name: 'buyBar',
      component: BuyBar,
    },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ],
});

// router.beforeResolve((to, from, next) => {
//   let token = Vue.cookie.get('i');
//   console.log(Vue);

//   // if (!token && to && to.name !== 'login') {
//   //   let newPath = `/${to.params.theatreId}/${to.params.session}/login`;

//   //   return next({path: newPath})
//   // }

//   return next();
// });

export default router;
